import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=2a5f5c64&scoped=true&lang=pug&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./notification.vue?vue&type=style&index=1&id=2a5f5c64&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f5c64",
  null
  
)

export default component.exports